import React, { useState, useEffect } from "react";
import { Box, Fade, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import MobileTopBar from "../../components/navigation/MobileTopBar";
import Button from "../../components/inputs/Button";
import TabButton from "../../components/inputs/TabButton";
import MessageBox from "../../components/utils/MessageBox";
import PlanCard from "../../components/cards/PlanCard";
import PaymentHistoryCard from "../../components/cards/PaymentHistoryCard";
import api from "../../components/api";

const PaymentsHistoryPage = ({ mobile, height, setLoggedIn, setUser, user, handleLogout }) => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPaymentsHistory = async () => {
    setLoading(true);
    api.getPaymentsHistory(
      (response) => {
        setPayments(response);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    getPaymentsHistory();
  }, []);

  const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  const formatNumberWithDots = (number) => {
    const numberString = number.toString();
    const parts = [];
    for (let i = numberString.length - 1; i >= 0; i -= 3) {
      const part = numberString.substring(Math.max(0, i - 2), i + 1);
      parts.unshift(part);
    }
    return parts.join(".");
  };

  return (
    <Box
      sx={{
        height: { height },
        overflow: "scroll",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        padding: "0px 10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      {mobile > 0 && (
        <MobileTopBar showBack onBack={() => navigate("/membresia")}>
          Historial de pagos
        </MobileTopBar>
      )}
      <Box
        style={{
          maxWidth: "700px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          marginTop: "15px",
        }}
      >
        {loading ? (
          <Typography
            style={{
              width: "100%",
              textAlign: "center",
              color: "#ffffff",
              fontWeight: "500",
              fontSize: "20px",
              marginLeft: "10px",
              width: "100%",
              marginTop: "10px",
            }}
          >
            Cargando pagos...
          </Typography>
        ) : payments.length > 0 ? (
          payments.map((payment) => (
            <PaymentHistoryCard
              paymentId={payment.id}
              paymentAmount={`$${formatNumberWithDots(payment.amount)}`}
              paymentDate={formatDate(payment.createdAt)}
              paymentDescription={
                payment.card
                  ? `Tarjeta ${payment.card.network} ${payment.card.cardNumber}`
                  : payment.merchantProcessor == "CASH"
                  ? "Efectivo"
                  : payment.merchantProcessor == "MERCADO_PAGO"
                  ? "Mercado Pago"
                  : "Transferencia Bancaria"
              }
              paymentStatus={payment.status}
            />
          ))
        ) : (
          <Typography
            style={{
              width: "100%",
              textAlign: "center",
              color: "#ffffff",
              fontWeight: "500",
              fontSize: "20px",
              marginLeft: "10px",
              width: "100%",
              marginTop: "10px",
            }}
          >
            No se encontraron pagos
          </Typography>
        )}

        {mobile > 0 && (
          <div
            style={{
              width: "100%",
              height: "70px",
              color: "rgba(0,0,0,0)",
            }}
          >
            -
          </div>
        )}
      </Box>
    </Box>
  );
};

export default PaymentsHistoryPage;
